import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function CookiesPolicy() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Header */}
      <header className="bg-[#0B1E36] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/70 hover:text-white mb-6 transition-colors"
            data-testid="back-to-home"
          >
            <ArrowLeft className="w-5 h-5" />
            Torna alla Home
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold">Cookies Policy</h1>
          <p className="text-white/70 mt-2">Ultimo aggiornamento: Gennaio 2025</p>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 py-12 md:py-16">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-[#E2E8F0]">
          <div className="prose prose-lg max-w-none">
            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">1. Cosa sono i Cookie</h2>
              <p className="text-[#64748B] leading-relaxed">
                I cookie sono piccoli file di testo che i siti visitati inviano al browser dell'utente, 
                dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva. 
                I cookie sono utilizzati per diverse finalità, hanno caratteristiche diverse e possono 
                essere utilizzati sia dal titolare del sito che da terze parti.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">2. Tipologie di Cookie Utilizzati</h2>
              
              <h3 className="text-xl font-semibold text-[#0B1E36] mt-6 mb-3">Cookie Tecnici</h3>
              <p className="text-[#64748B] leading-relaxed mb-4">
                Sono cookie necessari per il corretto funzionamento del sito web. Senza questi cookie, 
                il sito o alcune porzioni di esso potrebbero non funzionare correttamente. Questi cookie 
                non richiedono il consenso dell'utente.
              </p>
              <ul className="list-disc pl-6 text-[#64748B] space-y-2 mb-6">
                <li>Cookie di sessione per mantenere lo stato della navigazione</li>
                <li>Cookie per memorizzare preferenze dell'utente</li>
                <li>Cookie per il funzionamento dei form di contatto</li>
              </ul>

              <h3 className="text-xl font-semibold text-[#0B1E36] mt-6 mb-3">Cookie Analitici</h3>
              <p className="text-[#64748B] leading-relaxed mb-4">
                Sono cookie utilizzati per raccogliere informazioni sull'utilizzo del sito. Il Titolare 
                utilizza tali informazioni per analisi statistiche, per migliorare il sito e semplificarne 
                l'utilizzo, oltre che per monitorarne il corretto funzionamento.
              </p>

              <h3 className="text-xl font-semibold text-[#0B1E36] mt-6 mb-3">Cookie di Terze Parti</h3>
              <p className="text-[#64748B] leading-relaxed">
                Questo sito potrebbe utilizzare cookie di terze parti per:
              </p>
              <ul className="list-disc pl-6 text-[#64748B] space-y-2 mt-2">
                <li>Integrazione con social network (Facebook)</li>
                <li>Servizio WhatsApp per la messaggistica</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">3. Durata dei Cookie</h2>
              <p className="text-[#64748B] leading-relaxed mb-4">
                I cookie hanno una durata dettata dalla data di scadenza o da un'azione specifica come 
                la chiusura del browser impostata al momento dell'installazione.
              </p>
              <ul className="list-disc pl-6 text-[#64748B] space-y-2">
                <li><strong>Cookie di sessione:</strong> vengono cancellati alla chiusura del browser</li>
                <li><strong>Cookie persistenti:</strong> rimangono sul dispositivo fino alla loro scadenza 
                o cancellazione da parte dell'utente</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">4. Gestione dei Cookie</h2>
              <p className="text-[#64748B] leading-relaxed mb-4">
                L'utente può decidere se accettare o meno i cookie utilizzando le impostazioni del 
                proprio browser. La disabilitazione totale o parziale dei cookie tecnici può compromettere 
                l'utilizzo delle funzionalità del sito.
              </p>
              <p className="text-[#64748B] leading-relaxed mb-4">
                Di seguito i link alle istruzioni per la gestione dei cookie nei browser più diffusi:
              </p>
              <ul className="list-disc pl-6 text-[#64748B] space-y-2">
                <li>
                  <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#007AFF] hover:underline">
                    Google Chrome
                  </a>
                </li>
                <li>
                  <a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer" className="text-[#007AFF] hover:underline">
                    Mozilla Firefox
                  </a>
                </li>
                <li>
                  <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#007AFF] hover:underline">
                    Apple Safari
                  </a>
                </li>
                <li>
                  <a href="https://support.microsoft.com/it-it/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank" rel="noopener noreferrer" className="text-[#007AFF] hover:underline">
                    Microsoft Edge
                  </a>
                </li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">5. Consenso</h2>
              <p className="text-[#64748B] leading-relaxed">
                All'accesso al sito, l'utente visualizza un banner contenente un'informativa breve 
                sui cookie. Continuando la navigazione mediante accesso ad altra area del sito o 
                selezione di un elemento dello stesso, l'utente esprime il consenso all'uso dei cookie.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1E36] mb-4">6. Contatti</h2>
              <p className="text-[#64748B] leading-relaxed">
                Per qualsiasi domanda riguardante la presente Cookie Policy, è possibile contattarci:
                <br /><br />
                Email: <a href="mailto:info@finestreecolore.it" className="text-[#007AFF] hover:underline">info@finestreecolore.it</a>
                <br />
                Telefono: +39 327 282 3064
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-[#0B1E36] text-white py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Finestre e Colore. Tutti i diritti riservati.
          </p>
        </div>
      </footer>
    </div>
  );
}
